import React from 'react';
import './LogoView.scss';

export const LogoView = function () {
  return (
    <div className="logo">
      <div className="image"></div>
      <h2>RS-Lang</h2>
    </div>
  );
};
